/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */

import { MetricNamespaces } from "../operationsInterfaces/index.js";
import * as coreClient from "@azure/core-client";
import * as Mappers from "../models/mappers.js";
import * as Parameters from "../models/parameters.js";
import { MonitorManagementClientContext } from "../monitorManagementClientContext.js";
import {
  MetricNamespacesListOptionalParams,
  MetricNamespacesListResponse
} from "../models/index.js";

/** Class containing MetricNamespaces operations. */
export class MetricNamespacesImpl implements MetricNamespaces {
  private readonly client: MonitorManagementClientContext;

  /**
   * Initialize a new instance of the class MetricNamespaces class.
   * @param client Reference to the service client
   */
  constructor(client: MonitorManagementClientContext) {
    this.client = client;
  }

  /**
   * Lists the metric namespaces for the resource.
   * @param resourceUri The identifier of the resource.
   * @param options The options parameters.
   */
  list(
    resourceUri: string,
    options?: MetricNamespacesListOptionalParams
  ): Promise<MetricNamespacesListResponse> {
    return this.client.sendOperationRequest(
      { resourceUri, options },
      listOperationSpec
    );
  }
}
// Operation Specifications
const serializer = coreClient.createSerializer(Mappers, /* isXml */ false);

const listOperationSpec: coreClient.OperationSpec = {
  path: "/{resourceUri}/providers/microsoft.insights/metricNamespaces",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: Mappers.MetricNamespaceCollection
    },
    default: {
      bodyMapper: Mappers.ErrorResponse
    }
  },
  queryParameters: [Parameters.apiVersion, Parameters.startTime],
  urlParameters: [Parameters.$host, Parameters.resourceUri],
  headerParameters: [Parameters.accept],
  serializer
};
